import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];
  connect() { }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.remove("hidden");
    } else {
      this.menuTarget.classList.add("hidden");
    }
  }

  hide(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("filteritem")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }

  submit() {
    this.menuTarget.classList.remove("hidden");
  }
}
